export const juniorAdOperationsResume = `
【職務概要】
広告運用の分野で3年間の経験を積み、主にリスティング広告、ディスプレイ広告、SNS広告の運用を専門としています。特にGoogle広告とMeta広告の効果分析・改善において高い成果を上げてきました。これまでECサイトや自社サービスの広告運用を通じて、広告効果の最大化とROI改善に取り組み、平均して前年比120%の成果向上を実現してきました。

広告プラットフォームの仕様変更や市場動向に常にアンテナを張り、最新の広告手法やテクノロジーを積極的に取り入れることを心がけています。単なる広告運用だけでなく、LPOやクリエイティブ改善、コンバージョン経路の最適化など、マーケティングの全体設計を視野に入れた提案ができることが強みです。今後はより戦略的なプランニングスキルを磨きながら、広告運用の専門性を高めていきたいと考えています。

【職務経歴】
・株式会社Algomaticデジタルマーケティング（2022年4月〜現在）
  ○ 会社概要：デジタルマーケティングエージェンシー、従業員約50名、主に中小企業のWeb集客支援
  ○ 職務内容：広告運用スペシャリストとして、クライアント10社の広告運用を担当
  ○ 具体的な成果：
    - ECクライアントの広告運用において、ROAS前年比150%改善（月間予算300万円）
    - 新規顧客獲得単価を平均20%削減し、クライアントの顧客獲得コスト効率化に貢献
    - 広告クリエイティブのA/Bテスト実施によるコンバージョン率30%向上
  ○ 使用した技術・ツール：Google広告、Meta広告、Yahoo!広告、Twitter広告、Google Analytics 4、Google Tag Manager、SEMrush
  ○ 身につけたスキル：広告効果分析、クリエイティブ設計、競合分析、レポーティング、クライアントコミュニケーション

・株式会社Algomaticテクノロジーズ（2021年4月〜2022年3月）
  ○ 会社概要：SaaS型マーケティングツール開発企業、従業員約30名、BtoB向けソリューション提供
  ○ 職務内容：マーケティングアシスタントとして自社サービスの広告運用補助
  ○ 具体的な成果：
    - リードジェネレーション施策の実施により、月間リード獲得数を40件から70件に増加
    - ウェビナー集客広告の運用で参加率を15%向上
  ○ 使用した技術・ツール：Google広告、LinkedIn広告、HubSpot、Salesforce Marketing Cloud
  ○ 身につけたスキル：BtoBマーケティング基礎、リードナーチャリング、ウェビナー運営

・株式会社Algomaticソリューションズ（2020年6月〜2021年3月）
  ○ 会社概要：Web制作・マーケティングコンサルティング会社、従業員約15名
  ○ 職務内容：マーケティングインターン（アルバイト）として広告運用の基礎業務
  ○ 具体的な成果：
    - リスティング広告の入稿業務を効率化し、作業時間を30%短縮
    - 広告パフォーマンスの週次レポート作成と分析補助
  ○ 使用した技術・ツール：Google広告（基礎）、Google Analytics、Excel、PowerPoint
  ○ 身につけたスキル：データ分析基礎、広告運用基礎知識、レポーティング

【受賞・表彰歴】
・2023年8月 社内MVP賞「広告運用部門」受賞（四半期で最も成果を上げた社員として表彰）
・2023年2月 株式会社Algomaticデジタルマーケティング「新人賞」受賞

【資格】
・Google広告認定資格（検索広告）- 2021年5月取得
・Google広告認定資格（ディスプレイ広告）- 2021年6月取得
・Google広告認定資格（ショッピング広告）- 2022年1月取得
・Google Analytics個人認定資格（GAIQ）- 2022年3月取得
・Meta Blueprint認定 - 2022年9月取得

【マネジメント経験】
・2023年10月〜現在：新入社員1名の指導・育成担当
  ○ 広告運用の基礎から実践までのOJTトレーニングを実施
  ○ 週次での成長フィードバックとスキル定着度のチェック
  ○ 育成3ヶ月後、担当者単独で小規模クライアント（月間予算50万円）の運用が可能なレベルまで育成

【語学力】
・英語：ビジネス初級レベル（TOEIC 650点）
  ○ 英語の広告プラットフォーム操作、英語マニュアルの読解
  ○ 海外の広告トレンドに関する英語記事の読解
` as const;
